import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { CostItemUI } from '../types/cost/CostGetResponse';
import { EditModalItem } from '../types/cost/CostPutRequest';

export const COST_HEADER = [
  { label: '費用分類', sortable: false, sortKey: '', width: '180px' },
  { label: '内容', sortable: false, sortKey: '', width: '300px' },
  { label: '検収日', sortable: false, sortKey: '', width: '180px' },
  { label: '金額', sortable: false, sortKey: '', width: '150px' },
  { label: '操作', sortable: false, sortKey: '', width: '150px' },
];

export const COST_MODAL_FIELDS: FieldDescriptor<CostItemUI | EditModalItem>[] =
  [
    { label: '費用分類', key: 'category', type: 'text' },
    { label: '内容', key: 'detail', type: 'text' },
    { label: '検収日', key: 'date', type: 'date' },
    { label: '金額', key: 'price', type: 'text' },
  ];
